import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Updates: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Example updates data - in a real app, this would come from an API or database
  const updates = [
    {
      id: 'update-2025-01',
      date: '2025-01-27',
      title: 'January 2025 Updates',
      sections: {
        technical: [
          'Enhanced CICD Pipeline: Faster updates and bug fixes for seamless gameplay',
          'AI Retraining: Strengthening the AI agent\'s defenses by addressing vulnerabilities exposed in previous rounds',
          'AI Collaboration: Partnering with AI startups to refine detection and error correction capabilities',
          'Game Infrastructure: Improving response times, error handling, state memory, and automating game initiation and completion'
        ],
        engagement: [
          'Referral System: Players earn points and free plays by referring paying users',
          'Agent Communication: The AI agent actively interacts on Telegram, including group chats and managing the project\'s X (Twitter) account'
        ]
      }
    }
  ];

  return (
    <div className={`app ${document.body.classList.contains('dark-theme') ? 'dark-theme' : ''}`}>
      <div className="app-container">
        <div className="nes-container is-rounded with-title">
          <p className="title">Development Updates</p>
          
          <div className="page-navigation">
            <Link to="/" className="nes-btn is-primary">← Home</Link>
            <div className="nav-buttons">
              <Link to="/about" className="nes-btn">About</Link>
              <Link to="/tokenomics" className="nes-btn">Tokenomics</Link>
            </div>
          </div>

          <div className="updates-container">
            {/* Side Navigation */}
            <nav className="updates-nav">
              <ul>
                {updates.map(update => (
                  <li key={update.id}>
                    <a href={`#${update.id}`}>
                      {update.title}
                      <span className="update-date">{update.date}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Updates Content */}
            <div className="content-section">
              {updates.map(update => (
                <article key={update.id} id={update.id} className="update-entry">
                  <div className="update-header">
                    <span className="update-date">{update.date}</span>
                    <h2>{update.title}</h2>
                  </div>

                  <h3>Technical Improvements</h3>
                  <ul>
                    {update.sections.technical.map((item, index) => {
                      const [title, description] = item.split(': ');
                      return (
                        <li key={index}>
                          <strong>{title}:</strong> <em>{description}</em>
                        </li>
                      );
                    })}
                  </ul>

                  <h3>User Engagement Features</h3>
                  <ul>
                    {update.sections.engagement.map((item, index) => {
                      const [title, description] = item.split(': ');
                      return (
                        <li key={index}>
                          <strong>{title}:</strong> <em>{description}</em>
                        </li>
                      );
                    })}
                  </ul>
                </article>
              ))}
            </div>
          </div>

          <div className="legal-disclaimer">
            <p>DISCLAIMER: The development team reserves all rights to modify, amend, remove, or discontinue any aspect of the platform, features, or functionalities described above at any time and at its sole discretion, without prior notice. Nothing contained herein constitutes financial advice, a solicitation, recommendation, endorsement, or offer to purchase or sell any financial instruments or to participate in any particular trading strategy. All information is provided on an as-is basis for informational purposes only.</p>
          </div>

          <div className="page-footer">
            <div className="legal-links">
              <Link to="/disclaimer">Disclaimer</Link>
              <span className="separator">|</span>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms-of-use">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Updates; 